import React from 'react';
import { ServiceRecordStatusFilter, STATUS_MAP } from '../types';

interface StatusFilterProps {
  currentStatus: ServiceRecordStatusFilter;
  onSelectStatus: (status: ServiceRecordStatusFilter) => void;
  showArchived: boolean;
  onToggleShowArchived: (show: boolean) => void;
}

const ALL_STATUSES: Array<{ value: ServiceRecordStatusFilter; label: string }> = [
  { value: 'ACTIVE', label: 'Aktywne' },
  { value: 'RECEIVED', label: STATUS_MAP.RECEIVED.label },
  { value: 'DIAGNOSIS', label: STATUS_MAP.DIAGNOSIS.label },
  { value: 'WAITING_FOR_APPROVAL', label: STATUS_MAP.WAITING_FOR_APPROVAL.label },
  { value: 'IN_REPAIR', label: STATUS_MAP.IN_REPAIR.label },
  { value: 'READY', label: STATUS_MAP.READY.label },
  { value: 'HANDED_OVER', label: STATUS_MAP.HANDED_OVER.label },
  { value: 'ALL', label: 'Wszystkie' },
];

export const StatusFilter: React.FC<StatusFilterProps> = ({
  currentStatus,
  onSelectStatus,
  showArchived,
  onToggleShowArchived,
}) => {
  return (
    <div className="status-filter-container">
      <div className="status-tabs" role="tablist" aria-label="Filtry statusów">
        {ALL_STATUSES.map((st) => (
          <button
            key={st.value}
            type="button"
            className={`status-tab-btn ${currentStatus === st.value ? 'active' : ''}`}
            onClick={() => onSelectStatus(st.value)}
          >
            {st.label}
          </button>
        ))}
      </div>
      {currentStatus === 'ACTIVE' && (
        <div className="archive-toggle-wrapper">
          <label className="archive-toggle-label">
            <input
              type="checkbox"
              className="archive-toggle-checkbox"
              checked={showArchived}
              onChange={(e) => onToggleShowArchived(e.target.checked)}
            />
            <span className="archive-toggle-text">Pokaż archiwalne</span>
          </label>
        </div>
      )}
    </div>
  );
};
